import { excelNamesMatch } from "./columns";

interface FunctionDefinition {
  name: string;
  formula: string;
  description?: string;
}

export const DATA_TABLE_FUNCTION_NAMES = ["BreakoutIF", "GSF"];

const FUNCTIONS: FunctionDefinition[] = [
  {
    name: "BreakoutIF",
    formula: `=LAMBDA(condition,useGroupName,LET(
        colIndex, MATCH(useGroupName & "_$", Estimate[#Headers], 0), 
        targetColumn, INDEX(Estimate, , colIndex), 
        filteredValues, IF(condition, targetColumn, 0), 
        result, IFERROR(SUM(filteredValues), "Use Group Not Found"), 
        result))`,
    description: "Sums the USE GROUP breakout costs where the CONDITION is true",
  },
  {
    name: "GSF",
    formula: "=SUM(FloorAreas[total_area])",
  },
];

export const createFunctions = async (): Promise<void> => {
  await Excel.run(async (context) => {
    const workbookNames = context.workbook.names;
    await workbookNames.load("items/name");
    await context.sync();

    for (const f of FUNCTIONS) {
      try {
        const existingName = workbookNames.items.find((n) => excelNamesMatch(n.name, f.name));
        if (existingName) {
          existingName.delete();
          await context.sync();
        }
        workbookNames.add(f.name, f.formula, f.description);
      } catch (error) {
        console.warn(`Error creating function ${f.name}:`, error);
      }
    }

    await context.sync();
  });
};
